var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.594 19.25V3.437c0-1.519 1.063-2.75 2.375-2.75H17.03c1.312 0 2.375 1.231 2.375 2.75V19.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 17.188h14.25c.983 0 1.781.924 1.781 2.062 0 1.139-.798 2.063-1.781 2.063H3.375c-.983 0-1.781-.924-1.781-2.063 0-1.139.798-2.063 1.781-2.063zM6.344 4.813h8.313v6.875H6.344z"
  }))));
}
export default SvgIconBook;